import { Blockquote, Inset, Text } from "@radix-ui/themes";
import AddBottomSpace from "../../components/AddBottomSpace";
import AddHeadline from "../../components/AddHeadline";
import AddTopSpace from "../../components/AddTopSpace";

export default function Organization() {

  return (
    <>
      <AddTopSpace />
      <AddHeadline />
      <div className="container">

        <div className='row'>

          <div className='col-lg-4'>
            <div className="container py-3">
              <div className='row pb-1'>
                <div className='col'>
                  
                </div>
              </div>
            </div>
          </div>
          
          <div className='col-lg-8'>
            <div className="container py-3">
              <div className='row pb-3'>
                <div className='col'>
                  <Blockquote size="6" color>
                    Organization
                  </Blockquote>
                </div>
              </div>
            </div>
          </div>

        </div>

        <div className='row'>
          
          <div className='col-lg-4'>
            <div className="container py-3">
              <div className='row pb-1'>
                <div className='col'>
                  <Inset clip="padding-box" side="top" pb="current">
                    <img
                      src="https://www.shadvala.org/img/interstices-adrian.jpeg"
                      alt="Adrián Navigante"
                      style={{
                        display: 'block',
                        objectFit: 'cover',
                        width: '100%',
                        height: '100%',
                        backgroundColor: 'var(--gray-5)',
                      }}
                    />
                    <Text as="p" mb="5" size="2">
                      Adrián Navigante
                    </Text>
                  </Inset>
                </div>
              </div>
            </div>
          </div>
          
          <div className='col-lg-8'>
            <div className="container py-3">
              <div className='row pb-3'>
                <div className='col'>
                  <Blockquote size="6" mb="5" color>
                    Adrián Navigante
                  </Blockquote>
                  <Text as="p" mb="5" size="4">
                  Adrián Navigante is a poet and philosopher who has worked extensively on a symmetric dialogue between cultures (in Europe, India, Africa and South America). 
 After a PhD with summa cum laude at the University of Freiburg im Breisgau, he taught philosophy in different German and Austrian universities and extended his work to the fields of anthropology, depth psychology and history of religions. 
 He has worked as director of Research and Intellectual Dialogue at the Alain Daniélou Foundation for nine years and has been on the teaching staff of the C. G. Jung Institute in Zurich for sixteen years.
 He has published many volumes of poetry as well as essays in different languages on subjects varying from Western and Indian philosophy to New Anthropology and Depth Psychology.
                  </Text>
                </div>
              </div>
            </div>
          </div>

        </div>


        <div className='row'>
          
          <div className='col-lg-4'>
            <div className="container py-3">
              <div className='row pb-1'>
                <div className='col'>
                  <Inset clip="padding-box" side="top" pb="current">
                    <img
                      src="https://www.shadvala.org/img/interstices-amanda.jpg"
                      alt="Amanda Viana"
                      style={{
                        display: 'block',
                        objectFit: 'cover',
                        width: '100%',
                        height: '100%',
                        backgroundColor: 'var(--gray-5)',
                      }}
                    />
                    <Text as="p" mb="5" size="2">
                      Amanda Viana
                    </Text>
                  </Inset>
                </div>
              </div>
            </div>
          </div>
          
          <div className='col-lg-8'>
            <div className="container py-3">
              <div className='row pb-3'>
                <div className='col'>
                  <Blockquote size="6" mb="5" color>
                    Amanda Viana
                  </Blockquote>
                  <Text as="p" mb="5" size="4">
                    Amanda Viana de Sousa is a philosopher and passionate researcher of indigenous cultures of South America. 
                    She obtained a PhD in philosophy from the University of Freiburg im Breisgau, Germany. 
                    She conducted a post-doctoral research project from 2021 to 2024 at the University of Würzburg (Germany) in cooperation with the Alain Daniélou Foundation (Italy).
                    At <i>Interstices: Center for Transversal Thinking</i>, she organizes different interactions and carries out research activities on animism and Amerindian shamanism.
                    She was involved in the establishment of the Ailton Krenak Library (BAK) within the Brazilian initiative <i>Selvagem</i>, and she currently participates in several projects emphasizing the value of indigenous cultures in the global context.
                  </Text>
                </div>
              </div>
            </div>
          </div>

        </div>



      </div>
      
      <AddBottomSpace />
    </>
  )
}
